export const initialState = {
  // token names...
}

export const set = (state, payload) =>
  payload

export const update = (state, payload) => (
  { ...state, ...payload }
)
